import React, {createContext} from 'react';
import {Row, Col, Button, Modal, Icon, Tooltip} from "antd";
import BaseComponent from "../../../../../base/BaseComponent";
import {message} from "../../../../../utils/message";
import {Scrollbars} from "react-custom-scrollbars";
import FormItem from "../formItemTemplate/formItem";
import {regulation} from "../extendFieldsConfig";
import {showOrHide} from "../utils/utils";

export const PositionTypeContext = createContext();

export default class AuditRemarksModal extends BaseComponent {
    static defaultProps = {
        title: "附加信息"
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            formData: {}, //表单数据
            finalData: {}, //最终保存的数据
            auditRemarksData: [],  //审核备注数据
        }
    }

    componentDidMount() {

    }

    getFormData() {
        return this.state.finalData;
    }

    openSetFormData(processData, callBack, formData = {}) {
        this.callBack = callBack;
        this.setState({
            formData: JSON.parse(JSON.stringify(formData)),
            finalData: JSON.parse(JSON.stringify(formData)),
        }, () => this.getAuditRemarksData(processData, callBack))
    }

    callBack = () => {
    }

    getValue = (dbFieldName) => {
        if(typeof parseInt(dbFieldName) === "number") {
            return "this.state.formData['" + dbFieldName + "']";
        }else {
            return "this.state.formData." + dbFieldName;
        }
    }

    // 获取审核备注数据
    getAuditRemarksData = (processData, callBack) => {
        const {activityTypeData, id} = this.props;
        const processType = processData?.processData?.data?.processType;
        let url = "/cm-sites-media-consumer/system/activityField/getByPositionId";
        let {id: typeId} = activityTypeData.find(({type: activityType}) => activityType === processType) || {};
        let body = {id, typeId};
        if(processData?.done) {
            url = "/cm-sites-media-consumer/system/positionField/getByProcessId";
            body = {id: processData?.id};
        }
        this.request({
            url: url,
            body: body,
            callBack: (res) => {
                let auditRemarksData = [];
                if (res && res.length && (res.filter(item => item.status).length)) {
                    auditRemarksData = res.filter(item => item.status).map(item => ({
                        col: item.col,
                        componentType: regulation[item.fieldType],
                        value: this.getValue(item.dbFieldName),
                        labelName: item.fieldName,
                        labelCode: item.dbFieldName,
                        fieldProps: {
                            placeholder: this.getPlaceHolderText(item, item.fieldName),
                            message: this.getPlaceHolderText(item, item.fieldName),
                            size: "default", // 标签大小
                            options: item.fieldFillRules?.[0]?.keyValueMaps && Object.keys(item.fieldFillRules[0].keyValueMaps).length && Object.keys(item.fieldFillRules[0].keyValueMaps).map(i => ({
                                key: i,
                                label: item.fieldFillRules[0].keyValueMaps[i]
                            })),
                            fieldFillRules: item.fieldFillRules,
                            display: item.status ? "block" : "none",
                            disabled: true,
                            fieldType: item.fieldType,
                            fieldTip: item.fieldTip,
                            uploadCount: item.fieldFillRules && item.fieldFillRules?.[0]?.uploadCount,
                            show: item.show,
                            canEdit: item.canEdit,
                            confirmContent: item.fieldFillRules && item.fieldFillRules?.[0]?.confirmContent,
                        },
                        options: {
                            rules: this.setRules(item.fieldFillRules)
                        },
                        maxLength: 999,
                        required: item.required === -1 ? false : !!item.required,
                        id: "information_" + item.dbFieldName,
                    }));
                    this.state.visible = true;
                } else {
                    callBack && callBack();
                }
                this.setState({
                    auditRemarksData
                });
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };

    getPlaceHolderText(item, fieldName) {
        let requiredTip = item?.requiredTip;
        if ((typeof requiredTip === "number" && (requiredTip || requiredTip === 0)) ||
            (requiredTip && typeof requiredTip === "string" && requiredTip?.trim()?.length) ||
            (requiredTip && Array.isArray(requiredTip) && requiredTip?.length) ||
            (requiredTip && typeof requiredTip === 'object' && !Array.isArray(requiredTip) && Object.keys(requiredTip).length)
        ) {
            return requiredTip;
        }else {
            if (item.fieldType === 9) {
                return "请上传" + fieldName;
            } else if (item.fieldType === 1 || item.fieldType === 2 || item.fieldType === 7) {
                return "请输入" + fieldName;
            } else {
                return "请选择" + fieldName;
            }
        }
    }

    setRules(fieldFillRules) {
        let ruleArr = [];
        fieldFillRules.map(rule => {
            if (rule.ruleType === 0 && rule.length > 0) {
                ruleArr.push({
                    message: `内容不能超过${rule.length}个字`,
                    max: rule.length,
                    ruleType: rule.ruleType
                })
            }
            if (rule.ruleType === 1 && rule?.fieldRegularExpression) {
                ruleArr.push({
                    pattern: rule?.fieldRegularExpression?.regularDetails,
                    message: rule?.fieldRegularExpression?.regularTips,
                    ruleType: rule.ruleType
                })
            }
        })
        return ruleArr;
    }

    // 关闭弹窗
    onCancel = () => {
        this.setState({visible: false});
        if (typeof this.props.onCancel === 'function') {
            this.props.onCancel()
        }
    };

    render() {
        return (
            <>
                {this.renderAddModal()}
            </>
        )
    }

    // 审核备注弹窗
    renderAddModal = () => {
        return (
            <Modal
                centered={true}
                title={this.props.title}
                visible={this.state.visible}
                maskClosable={false}
                keyboard={false}
                onCancel={() => {
                    this.onCancel()
                }}
                width={800}
                destroyOnClose={true}
                okText="确定"
                footer={
                    this.renderFooter()
                }
            >
                <Scrollbars autoHide autoHeight autoHeightMax={300}>
                    <Row>
                        {this.renderDynamicForm()}
                    </Row>
                </Scrollbars>
            </Modal>
        )
    };

    formIsDisabled = () => {
        const {isAuditing, noDisabled} = this.props;
        let result = false;
        // 审核中 && 需要禁用  =>>>  禁用
        if (isAuditing && !noDisabled) {
            result = true;
        }
        return result;
    }

    renderFooter = () => {
        return (
            <>
                <Button onClick={() => {
                    this.onCancel()
                }}>关闭</Button>
            </>
        )
    };

    // 中断错误方法
    errFun = (msg) => {
        window.loading.hide();
        if (msg) {
            message.warning(msg, 1);
        }
    };

    // 表单校验
    checkForm = () => {
        let {auditRemarksData} = this.state;
        // 隐藏的字段不校验
        let newAuditRemarksData = auditRemarksData.filter(item => {
            return !item.fieldProps.show || showOrHide(item.fieldProps.show, this.getValueByKey)
        })
        // 2、校验动态字段
        for (let j = 0; j < newAuditRemarksData.length; j++) {
            let dynamicItem = newAuditRemarksData[j];
            let dynamicItemVal = Function(`return ${dynamicItem.value}`).call(this);
            // 校验必填
            if (dynamicItem.required) {
                if (!((typeof dynamicItemVal === "number" && dynamicItemVal) ||
                    (dynamicItemVal && typeof dynamicItemVal === "string" && dynamicItemVal?.trim()?.length) ||
                    (dynamicItemVal && Array.isArray(dynamicItemVal) && dynamicItemVal?.length) ||
                    (dynamicItemVal && typeof dynamicItemVal === 'object' && !Array.isArray(dynamicItemVal) && Object.keys(dynamicItemVal).length) ||
                    (dynamicItemVal && typeof dynamicItemVal === "boolean")
                )) {
                    this.errFun(dynamicItem.fieldProps.message);
                    return false;
                }
                if(dynamicItemVal && Array.isArray(dynamicItemVal) && dynamicItemVal.some(item => item.status === "uploading")) {
                    this.errFun(dynamicItem.fieldProps.message);
                    return false;
                }
            }
            // 校验正则
            if (dynamicItem?.options?.rules?.length) {
                let dynamicRegularRules = dynamicItem.options.rules;
                for (let n = 0; n < dynamicRegularRules.length; n++) {
                    let ruleItem = dynamicRegularRules[n];
                    if (ruleItem.ruleType === 1 && !(dynamicItemVal && dynamicItemVal.trim() && ruleItem.pattern && new RegExp(ruleItem.pattern).test(dynamicItemVal))) {
                        this.errFun(ruleItem.message);
                        return false;
                    }
                    if (ruleItem.ruleType === 0 && dynamicItemVal?.trim()?.length > ruleItem.max && ruleItem.max !== 0) {
                        let regMessage = `${dynamicItem.labelName}内容不能超过${ruleItem.max}个字`;
                        this.errFun(regMessage);
                        return false;
                    }
                }
            }
        }
        return true;
    };

    // 保存
    onOk = () => {
        let body = this.checkForm();
        if (!body) {
            return false;
        }
        this.state.finalData = this.state.formData;
        if (typeof this.callBack !== "function") this.state.visible = false;
        this.setState({}, () => {
            this.callBack && this.callBack();
        })
    };

    renderDynamicForm = () => {
        let auditRemarksData = this.state.auditRemarksData;
        if (!(auditRemarksData && auditRemarksData.length)) return null
        return auditRemarksData.map(item => {
            return this.renderFixedField(item)
        })
    };

    getValueByKey = (dbFieldName) => {
        return this.state.formData[dbFieldName];
    }

    renderFixedField = ({
                            componentType = "input",
                            multiple = false,
                            auth = '',
                            value = "",
                            labelCode = "",
                            labelName = "未知",
                            placeholder = "请输入",
                            required = false,
                            disabled = false,
                            size = "default",
                            id = `information_${labelCode}`,
                            col = 12,
                            fieldProps = {},
                            options = {}
                        }) => {

        let onFieldsChange = (val, se) => {
            this.onInformationChange({code: value, val})
        };

        let isShow = showOrHide(fieldProps.show || true, this.getValueByKey);
        if(fieldProps.show && !isShow) {
            delete this.state.formData[labelCode];
            return <Col span={0} key={id} className='fieldsCol'></Col>;
        }

        // 判断是否拥有权限-渲染内容为占位
        if (!!auth && !this.permissionCheck(auth)) return <Col span={col} key={id} className='fieldsCol'></Col>;
        const {isAuditing, isUpdateInfo} = this.props;
        return (
            <Col span={col} key={id} className={"fieldsCol"}>
                <PositionTypeContext.Provider value={{...this.state, changeData: (data) => this.setState({data})}}>
                    <FormItem
                        formKey={labelCode}
                        itemType={componentType}
                        label={this.renderLabel({labelName, ...fieldProps})}
                        fieldProps={{
                            ...fieldProps,
                            col,
                            required,
                            labelName,
                            value: eval(value),
                            onChange: onFieldsChange,
                            isAuditing,
                            isUpdateInfo
                        }}
                        required={required}
                        setValidatedStatus={!!Object.keys(this.state.formData).length}
                        hasFeedback={true}
                        options={
                            {
                                ...options
                            }
                        }
                    />
                </PositionTypeContext.Provider>
                <style>{`.fieldsCol{padding: 0 10px;}`}</style>
            </Col>
        )
    };

    renderLabel = ({labelName, fieldTip}) => {
        return (labelName && <span>
            {labelName}<Tooltip placement="top" title={fieldTip}>
            <span style={{
                display: fieldTip ? "inline-block" : "none",
                marginLeft: 5,
                cursor: 'pointer'
            }}><Icon type="question-circle"/></span></Tooltip>
        </span>)
    }

    onInformationChange = ({code, val, setState = true}) => {
        eval(`${code} = val`);
        // 方案一 eval(`obj.${key}=value`);
        // 方案二 new Function('obj','key','value',`obj.${key}=value`)(obj,key,value);
        // 备注：只有动态字段需要使用${}包裹
        if (setState) {
            this.setState({});
        }
    };

}
